// extracted by mini-css-extract-plugin
export default {"compareSection":"HistoryCompare_compareSection__HPB2Z"};